export const REQUEST_CHOOSE_PATH = "request_choose_path"
export const CHOOSE_PATH_SUCCESS = "choose_path_success"
export const CHOOSE_PATH_FAILURE = "choose_path_failure"

export const CLEAR_CHOOSE_PATH_STATE = "clear_choose_path_state"